import React from 'react';
import VisuallyHidden from '@reach/visually-hidden';

import iconify from '../iconify';

const LogoSkillup = ({negative, ...props}) => {
  let textColor = '#4d4d4d';
  let subColor = 'url(#linear-gradient)';
  if (negative) {
    textColor = 'currentColor';
    subColor = 'currentColor';
  }

  return (
    <>
      <VisuallyHidden>
        <span lang="en">Skillup</span> Logo
      </VisuallyHidden>
      <svg
        aria-hidden="true"
        width="5.28em"
        height="2.5em"
        viewBox="25 26.9 88.3 21.1"
        {...props}
      >
        <defs>
          <linearGradient
            id="linear-gradient"
            x1={0.001}
            y1={0.509}
            x2={1.001}
            y2={0.509}
            gradientUnits="objectBoundingBox"
          >
            <stop offset={0} stopColor="#d3793b" />
            <stop offset={1} stopColor="#ea4154" />
          </linearGradient>
        </defs>
        <g transform="translate(25 26.9)">
          <g fill={textColor}>
            <path d="M0 18.8l1.5-2.3a8.209 8.209 0 0 0 4.8 1.8c1.5 0 2.3-.6 2.3-1.6v-.1c0-1.1-1.6-1.5-3.3-2.1C3.1 13.9.7 13 .7 10.2v-.1C.7 7.3 3 5.6 6 5.6a9.59 9.59 0 0 1 5.4 1.7l-1.3 2.4a9.223 9.223 0 0 0-4.2-1.3c-1.3 0-2.1.6-2.1 1.5v.1c0 1.1 1.6 1.5 3.3 2.1 2.2.7 4.6 1.7 4.6 4.3v.1c0 3.1-2.4 4.6-5.5 4.6A10.794 10.794 0 0 1 0 18.8z" />
            <path d="M15.2.3h3.4v12.2L24.8 6h4.1L23 12l6.1 8.8h-4l-4.4-6.4-2.1 2.2v4.2h-3.4V.3z" />
            <path d="M31.6.5h3.6v3.2h-3.6zm.1 5.5h3.4v14.8h-3.4V6z" />
            <path d="M39.8.3h3.4v20.4h-3.4z" />
            <path d="M47.8.3h3.4v20.4h-3.4z" />
            <path d="M55.4 9.7V.3h3.4v8.4c0 2.3 1.1 3.6 3.2 3.6 2 0 3.3-1.3 3.3-3.6V.3h3.4v14.8h-3.4v-2.3a5.339 5.339 0 0 1-4.6 2.6c-3.4 0-5.3-2.2-5.3-5.7z" />
            <path d="M72.9.3h3.4v2.5A5.933 5.933 0 0 1 81.4 0c3.5 0 6.9 2.7 6.9 7.7v.1c0 4.9-3.4 7.7-6.9 7.7a5.8 5.8 0 0 1-5-2.6v8H73V.3zm11.9 7.4c0-2.9-1.9-4.8-4.2-4.8a4.434 4.434 0 0 0-4.3 4.7v.1a4.434 4.434 0 0 0 4.3 4.7c2.3.1 4.2-1.8 4.2-4.7z" />
          </g>
          <path fill={subColor} d="M68.7 17.6v3.1H55.4v-3.1z" />
        </g>
      </svg>
    </>
  );
};

export default iconify(LogoSkillup);
